import { Component, forwardRef } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select'
import { MatOptionModule } from '@angular/material/core'
import { TranslateModule } from '@ngx-translate/core'

@Component({
  selector: 'app-timezone-selector',
  standalone: true,
  imports: [MatFormFieldModule, MatSelectModule, MatOptionModule, TranslateModule],
  templateUrl: './timezone-selector.component.html',
  styleUrls: ['./timezone-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TimezoneSelectorComponent),
      multi: true,
    },
  ],
})
export class TimezoneSelectorComponent implements ControlValueAccessor {
  timezones: string[] = Intl.supportedValuesOf('timeZone')
  currentTimezone!: string
  disabled = false

  private onChange: (value: string | null) => void = () => {}
  private onTouched: () => void = () => {}

  writeValue(value: string): void {
    this.currentTimezone = value
  }

  registerOnChange(fn: (value: string | null) => void): void {
    this.onChange = fn
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled
  }

  onChangeTimezone(newTimezone: string): void {
    this.currentTimezone = newTimezone
    this.onChange(this.currentTimezone)
    this.onTouched()
  }
}
